import { NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { LabelModule } from '@progress/kendo-angular-label';
import { ValidationErrorKeysPipe, validationMessages } from '../../pipes/validation-error-keys.pipe';

@Component({
  selector: 'shared-ui-text-input',
  templateUrl: './shared-ui-text-input.component.html',
  styleUrls: ['./shared-ui-text-input.component.scss'],
  standalone: true,
  imports: [NgIf, LabelModule, FormsModule, ReactiveFormsModule, NgbAlert, NgFor, ValidationErrorKeysPipe]
})
export class SharedUiTextInputComponent {
  @Input() label = '';
  @Input() control?: FormControl;
  @Input() placeholder?: string;
  @Input() messages = validationMessages;
  @Input() isReadOnly: boolean = false;
}
